import { render, staticRenderFns } from "./MirrorsRedirectors.vue?vue&type=template&id=466d557c&scoped=true&"
import script from "./MirrorsRedirectors.vue?vue&type=script&lang=js&"
export * from "./MirrorsRedirectors.vue?vue&type=script&lang=js&"
import style0 from "./MirrorsRedirectors.vue?vue&type=style&index=0&id=466d557c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d557c",
  null
  
)

export default component.exports